// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner {
  align-content: flex-start;
  display: flex;
  flex-wrap: wrap;
  min-height: 804px;
  justify-content: center;
  width: 100%;
}

.banner:not(:has(.banner--container .banner--form)) {
  min-height: 734px;
}

.banner--container {
  background: var(--color-primary-light-yellow);
  border-radius: 0px 0px 24px 24px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 90px;
  max-width: var(--grid-max-width);
  padding: 0 24px;
  position: relative;
  width: 100%;
}

.banner--container:not(:has(.banner--form)) {
  padding: 0 24px 60px;
}

.banner--container:before {
  background: var(--color-primary-red);
  border-radius: 0px 0px 50px 50px;
  bottom: -8px;
  content: '';
  height: 8px;
  left: 50%;
  max-width: calc(var(--grid-max-width) - (30px * 2));
  position: absolute;
  transform: translate3d(-50%, 0px, 0px);
  width: 100%
}

.banner--container:after {
  background: var(--color-primary-green-ethanol);
  border-radius: 0px 0px 50px 50px;
  bottom: -22px;
  content: '';
  height: 8px;
  left: 50%;
  max-width: calc(var(--grid-max-width) - (44px * 2));
  position: absolute;
  transform: translate3d(-50%, 0px, 0px);
  width: 100%
}

.banner--info {
  align-items: center;
  display: flex;
  gap: 14px;
  flex-wrap: nowrap;
  max-width: 900px;
  width: 100%;
  color: var(--color-contrast-dark-gray);
  padding-top: 15px;
}

.banner--info span {
  color: var(--color-contrast-dark-red);
}

.banner--main {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.banner--main--images {
  height: 455px;
  max-width: 786px;
  position: relative;
  width: 100%;
  right: 60px;
}

.banner--main--images img {
  position: absolute;
}

.banner--main--images img[alt=moto] {
  bottom: 0px;
  left: 0px;
}

.banner--main--images img[alt=tv] {
  left: calc(50% - 25px);
  top: 40px;
  transform: translate3d(-50%, 0px, 0px);
}

.banner--main--images--items {
  bottom: -20px;
  display: flex;
  height: 320px;
  right: 0px;
  position: absolute;
  width: 280px;
}

.banner--main--images img[alt=alexa] {
  bottom: 90px;
  right: 76px;
}
.banner--main--images img[alt=airpods] {
  bottom: 70px;
  right: 144px;
}
.banner--main--images img[alt=tablet] {
  bottom: 110px;
  right: 75px;
}
.banner--main--images img[alt=iphone] {
  bottom: 110px;
  right: 0px;
}
.banner--main--images img[alt=applewatch] {
  bottom: 90px;
  right: 206px;
}

.banner--form {
  align-items: center;
  display: flex;
  gap: 18px;
  justify-content: center;
  padding: 40px 0px;
  text-align: center;
  width: 100%;
}
.banner--form .btn-primary {
  padding: 14px 20px;
}
.banner--form .btn-primary.secondary {
  color: var(--color-primary-red);
}

.banner--logo {
  align-items: flex-start;
  background: var(--color-contrast-dark-yellow);
  border-radius: 18px;
  display: flex;
  left: 120px;
  flex-flow: column wrap;
  justify-content: flex-start;
  justify-content: center;
  padding: 40px;
  position: relative;
  top: 54px;
  width: auto;
}
.banner--logo:before,
.banner--logo:after {
  border-radius: 21px 0px 0px 21px;
  content: '';
  position: absolute;
  width: 18px;
}
.banner--logo:before {
  background: var(--color-primary-green-ethanol);
  left: -44px;
  height: calc(100% - (13px * 4));
}
.banner--logo:after {
  background: var(--color-primary-red);
  height: calc(100% - (13px * 2));
  left: -18px;
}

.banner--logo p,
.banner--logo h1 span {
  color: var(--color-primary-red);
}
.banner--logo h1 {
  color: var(--color-primary-green-ethanol);
  width: 246px;
}

@media (max-width: 768px) {
  .banner:not(:has(.banner--container .banner--form)) {
    min-height: 650px;
  }

  .banner--container {
    padding: 0 16px;
  }

  .banner--container:before,
  .banner--container:after {
    height: 4px;
  }
  .banner--container:before {
    bottom: -4px;
    width: calc(100% - (30px * 2));
  }
  .banner--container:after {
    bottom: -10px;
    width: calc(100% - (34px * 2));
  }

  .banner--form {
    flex-flow: column wrap;
    padding: 24px 0px;
    width: auto;
  }
  .banner--form button {
    width: 100%;
  }

  .banner--info {
    padding: 15px 17px 0;
    align-items: flex-start;
  }

  .banner--info img {
    width: 48px;
  }

  .banner--info .p1-paragraph {
    font-size: 14px;
  }

  .banner--main {
    align-items: center;
    flex-flow: column wrap;
    justify-content: center;
    margin-top: 40px;
  }
  .banner--main--images {
    height: 220px;
    max-width: 366px;
    width: 100%;
    margin-bottom: 20px;
    right: 0;
  }

  .banner--logo {
    border-radius: 6px;
    padding: 18px 24px;
    left: 0px;
    top: 0px;
    width: 222px;
  }
  .banner--logo:before, .banner--logo:after {
    border-radius: 8px 0px 0px 8px;
    width: 6px;
  }
  .banner--logo:before {
    height: calc(100% - (6px * 4));
    left: -16px;
  }
  .banner--logo:after {
    height: calc(100% - (4px * 4));
    left: -6px;
  }
  .banner--logo h1 {
    font-size: 27px;
    width: auto;
  }
  .banner--logo .display-2 {
    font-size: 14px;
  }

  .banner--main--images--items {
    height: 100px;
    width: 150px;
    bottom: 15px;
  }

  .banner--main--images img[alt=alexa] {
    bottom: 0;
    left: 75px;
    width: 77px;
  }
  .banner--main--images img[alt=airpods] {
    bottom: 0;
    left: 36px;
    width: 60px;
  }
  .banner--main--images img[alt=tablet] {
    bottom: 22px;
    left: 30px;
    width: 100px;
  }
  .banner--main--images img[alt=iphone] {
    top: 50%;
    right: -15px;
    width: 65px;
    transform: translateY(-70%);
  }
  .banner--main--images img[alt=applewatch] {
    bottom: 15px;
    left: 20px;
    width: 32px;
  }

  .banner--main--images img[alt=moto] {
    width: 230px;
  }
  
  .banner--main--images img[alt=tv] {
    left: 37px;
    top: 29px;
    transform: none;
    width: 235px;
  }
}`, "",{"version":3,"sources":["webpack://./src/scripts/components/banner/styles.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,YAAY;EACZ,WAAW;EACX,WAAW;EACX,SAAS;EACT,mDAAmD;EACnD,kBAAkB;EAClB,sCAAsC;EACtC;AACF;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,WAAW;EACX,SAAS;EACT,mDAAmD;EACnD,kBAAkB;EAClB,sCAAsC;EACtC;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,6CAA6C;EAC7C,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;;EAEE,gCAAgC;EAChC,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,8CAA8C;EAC9C,WAAW;EACX,+BAA+B;AACjC;AACA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,WAAW;AACb;;AAEA;;EAEE,+BAA+B;AACjC;AACA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;EACb;EACA;IACE,YAAY;IACZ,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;EACd;EACA;IACE,8BAA8B;IAC9B,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,WAAW;EACb;EACA;IACE,8BAA8B;IAC9B,UAAU;EACZ;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,SAAS;IACT,UAAU;IACV,WAAW;EACb;EACA;IACE,SAAS;IACT,UAAU;IACV,WAAW;EACb;EACA;IACE,YAAY;IACZ,UAAU;IACV,YAAY;EACd;EACA;IACE,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,2BAA2B;EAC7B;EACA;IACE,YAAY;IACZ,UAAU;IACV,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,SAAS;IACT,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":[".banner {\n  align-content: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  min-height: 804px;\n  justify-content: center;\n  width: 100%;\n}\n\n.banner:not(:has(.banner--container .banner--form)) {\n  min-height: 734px;\n}\n\n.banner--container {\n  background: var(--color-primary-light-yellow);\n  border-radius: 0px 0px 24px 24px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-bottom: 90px;\n  max-width: var(--grid-max-width);\n  padding: 0 24px;\n  position: relative;\n  width: 100%;\n}\n\n.banner--container:not(:has(.banner--form)) {\n  padding: 0 24px 60px;\n}\n\n.banner--container:before {\n  background: var(--color-primary-red);\n  border-radius: 0px 0px 50px 50px;\n  bottom: -8px;\n  content: '';\n  height: 8px;\n  left: 50%;\n  max-width: calc(var(--grid-max-width) - (30px * 2));\n  position: absolute;\n  transform: translate3d(-50%, 0px, 0px);\n  width: 100%\n}\n\n.banner--container:after {\n  background: var(--color-primary-green-ethanol);\n  border-radius: 0px 0px 50px 50px;\n  bottom: -22px;\n  content: '';\n  height: 8px;\n  left: 50%;\n  max-width: calc(var(--grid-max-width) - (44px * 2));\n  position: absolute;\n  transform: translate3d(-50%, 0px, 0px);\n  width: 100%\n}\n\n.banner--info {\n  align-items: center;\n  display: flex;\n  gap: 14px;\n  flex-wrap: nowrap;\n  max-width: 900px;\n  width: 100%;\n  color: var(--color-contrast-dark-gray);\n  padding-top: 15px;\n}\n\n.banner--info span {\n  color: var(--color-contrast-dark-red);\n}\n\n.banner--main {\n  align-items: flex-start;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.banner--main--images {\n  height: 455px;\n  max-width: 786px;\n  position: relative;\n  width: 100%;\n  right: 60px;\n}\n\n.banner--main--images img {\n  position: absolute;\n}\n\n.banner--main--images img[alt=moto] {\n  bottom: 0px;\n  left: 0px;\n}\n\n.banner--main--images img[alt=tv] {\n  left: calc(50% - 25px);\n  top: 40px;\n  transform: translate3d(-50%, 0px, 0px);\n}\n\n.banner--main--images--items {\n  bottom: -20px;\n  display: flex;\n  height: 320px;\n  right: 0px;\n  position: absolute;\n  width: 280px;\n}\n\n.banner--main--images img[alt=alexa] {\n  bottom: 90px;\n  right: 76px;\n}\n.banner--main--images img[alt=airpods] {\n  bottom: 70px;\n  right: 144px;\n}\n.banner--main--images img[alt=tablet] {\n  bottom: 110px;\n  right: 75px;\n}\n.banner--main--images img[alt=iphone] {\n  bottom: 110px;\n  right: 0px;\n}\n.banner--main--images img[alt=applewatch] {\n  bottom: 90px;\n  right: 206px;\n}\n\n.banner--form {\n  align-items: center;\n  display: flex;\n  gap: 18px;\n  justify-content: center;\n  padding: 40px 0px;\n  text-align: center;\n  width: 100%;\n}\n.banner--form .btn-primary {\n  padding: 14px 20px;\n}\n.banner--form .btn-primary.secondary {\n  color: var(--color-primary-red);\n}\n\n.banner--logo {\n  align-items: flex-start;\n  background: var(--color-contrast-dark-yellow);\n  border-radius: 18px;\n  display: flex;\n  left: 120px;\n  flex-flow: column wrap;\n  justify-content: flex-start;\n  justify-content: center;\n  padding: 40px;\n  position: relative;\n  top: 54px;\n  width: auto;\n}\n.banner--logo:before,\n.banner--logo:after {\n  border-radius: 21px 0px 0px 21px;\n  content: '';\n  position: absolute;\n  width: 18px;\n}\n.banner--logo:before {\n  background: var(--color-primary-green-ethanol);\n  left: -44px;\n  height: calc(100% - (13px * 4));\n}\n.banner--logo:after {\n  background: var(--color-primary-red);\n  height: calc(100% - (13px * 2));\n  left: -18px;\n}\n\n.banner--logo p,\n.banner--logo h1 span {\n  color: var(--color-primary-red);\n}\n.banner--logo h1 {\n  color: var(--color-primary-green-ethanol);\n  width: 246px;\n}\n\n@media (max-width: 768px) {\n  .banner:not(:has(.banner--container .banner--form)) {\n    min-height: 650px;\n  }\n\n  .banner--container {\n    padding: 0 16px;\n  }\n\n  .banner--container:before,\n  .banner--container:after {\n    height: 4px;\n  }\n  .banner--container:before {\n    bottom: -4px;\n    width: calc(100% - (30px * 2));\n  }\n  .banner--container:after {\n    bottom: -10px;\n    width: calc(100% - (34px * 2));\n  }\n\n  .banner--form {\n    flex-flow: column wrap;\n    padding: 24px 0px;\n    width: auto;\n  }\n  .banner--form button {\n    width: 100%;\n  }\n\n  .banner--info {\n    padding: 15px 17px 0;\n    align-items: flex-start;\n  }\n\n  .banner--info img {\n    width: 48px;\n  }\n\n  .banner--info .p1-paragraph {\n    font-size: 14px;\n  }\n\n  .banner--main {\n    align-items: center;\n    flex-flow: column wrap;\n    justify-content: center;\n    margin-top: 40px;\n  }\n  .banner--main--images {\n    height: 220px;\n    max-width: 366px;\n    width: 100%;\n    margin-bottom: 20px;\n    right: 0;\n  }\n\n  .banner--logo {\n    border-radius: 6px;\n    padding: 18px 24px;\n    left: 0px;\n    top: 0px;\n    width: 222px;\n  }\n  .banner--logo:before, .banner--logo:after {\n    border-radius: 8px 0px 0px 8px;\n    width: 6px;\n  }\n  .banner--logo:before {\n    height: calc(100% - (6px * 4));\n    left: -16px;\n  }\n  .banner--logo:after {\n    height: calc(100% - (4px * 4));\n    left: -6px;\n  }\n  .banner--logo h1 {\n    font-size: 27px;\n    width: auto;\n  }\n  .banner--logo .display-2 {\n    font-size: 14px;\n  }\n\n  .banner--main--images--items {\n    height: 100px;\n    width: 150px;\n    bottom: 15px;\n  }\n\n  .banner--main--images img[alt=alexa] {\n    bottom: 0;\n    left: 75px;\n    width: 77px;\n  }\n  .banner--main--images img[alt=airpods] {\n    bottom: 0;\n    left: 36px;\n    width: 60px;\n  }\n  .banner--main--images img[alt=tablet] {\n    bottom: 22px;\n    left: 30px;\n    width: 100px;\n  }\n  .banner--main--images img[alt=iphone] {\n    top: 50%;\n    right: -15px;\n    width: 65px;\n    transform: translateY(-70%);\n  }\n  .banner--main--images img[alt=applewatch] {\n    bottom: 15px;\n    left: 20px;\n    width: 32px;\n  }\n\n  .banner--main--images img[alt=moto] {\n    width: 230px;\n  }\n  \n  .banner--main--images img[alt=tv] {\n    left: 37px;\n    top: 29px;\n    transform: none;\n    width: 235px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
